---
pageId: concept-journal
title: What is the Journal
description: The Journal is the day-by-day timeline of everything you record in Samlla — one day at a time, with entries, notes and a stats sidebar.
category: concepts
order: 2
lang: en
slug: concepts/journal
updated: 2026-10-16
---

The Journal is where your days live. It shows one day at a time as a timeline of entries — everything you logged, across all trackers, in the order it happened. Logging happens here; deeper analysis lives on the Stats page.

## What an entry looks like

Each entry carries its time, the tracker it belongs to, and — depending on the tracker — metric values, free-form notes and tags. The first metric of a tracker is the primary one and renders large; the rest follow in a compact row. Entries synced from integrations arrive with a source tag, so you always know where a value came from.

Notes-only entries from journal-mode trackers render the note as the main body, with longer texts folded behind a "more" expander.

## One day, two ways to read it

Every day can be viewed in two modes, toggled from the day header:

- **Timeline view** — strictly chronological, entry by entry.
- **Grouped view** — all entries of the same tracker folded together.

Today defaults to the timeline; past days default to grouped. The Journal also folds repetition for you: consecutive entries of one tracker collapse into a single card with a count badge and a time range, and a tracker with many entries in one day folds entirely. Notes are never folded away.

Days without entries stay honest: a single empty day is a quiet row, and longer gaps collapse into one expandable line counting the days — no guilt attached.

## Moving through time

- **Arrow keys** — left for the previous day, right for the next (capped at today); **t** jumps back to today.
- **Go to date** opens a calendar.
- **Scrolling down** keeps loading earlier days, all the way to the first entry you ever made — the Journal tells you when you have reached the beginning.

The focused date lives in the URL, so any day can be bookmarked or shared as a link.

## The stats sidebar

Alongside the timeline sits a compact sidebar with the current week (or last 7 days — your choice is remembered): **Days with entries**, **Entries** and **Active trackers**, plus an **Activity** section with a small bar chart per tracker linking to its page.

## History and plans

On the Free plan the Journal scrolls back 90 days; your full history is safely stored and Pro unlocks all of it. For weekly, monthly and yearly perspectives, head to the Stats page — that is where the wide views live.
